module.exports = ".breadcrumb-background {\r\n    /* background-color: #d8d8d8; */\r\n    padding: 0 15px;\r\n  }\r\n  .p-30px{\r\n    padding: 30px\r\n  }\r\n"